import './PanPrintComp.css'; 
import SharePage from '../SharePage.js';

let PanPrintComp=(props)=>{ 
    if(props.paninputs.name==undefined){
        window.location="/pan-manual";
    }
    let panprintfun =()=>{
        window.print();
        document.querySelector(".panprintmaindiv").style.display="none";
        document.querySelector(".panprintbtn").style.display="none";
        document.querySelector(".sharecont").style.display="block";
    }
    return(
        <div className='panmaincont'>
            <div className='panprintmaindiv'>
                <img alt='photo' className='PanPhoto' src={props.paninputs.photo}/>
                {
                    props.paninputs.sig != undefined ? <img alt='signature' className='sig' src={props.paninputs.sig}/> : ""
                } 
                
                <img alt='qr code' className='qr' src={props.paninputs.qr}/>
                <span className='pannamee'>{props.paninputs.name}</span>
                <span className='pannumber'>{props.paninputs.pannumber}</span>
                <span className='fathername'>{props.paninputs.fathername}</span>
                <span className='dob'>{props.paninputs.dob}</span> 
                
            </div>
            <button onClick={panprintfun} className='panprintbtn'>Print</button>
            <div className='sharecont' style={{display:"none"}}>
                    <SharePage path='/MakeResume' title='Make free resumes' description="Make resumes for jobs, schools and many more for free"/>

            </div>
        </div>
        
    );
}
export default PanPrintComp;